<p>
  image-add works!
</p>
